<template>
  <div id="header" class="top-fixed">
    <div id="status" class="status-bar"></div>
    <div class="header">
      <div class="left-btn" v-if="isback" @click="goback()">
        <i class="iconfont icon-houtui gray6 f36"></i>
      </div>
      <div class="header-txt">{{title || '悦小妖'}}</div>
      <div class="right-btn" id="right_btn" v-show="showRight">
        <a class="editok right">
          <i class="f26 ionicons ion-share share"></i>
        </a>
      </div>
    </div>
  </div>
</template>
<style rel="stylesheet/scss" lang="scss">
@import "../assets/sass/tool";
//顶部返回导航
.top-fixed {
  width: 100%;
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 102;
  left: 0;
  text-align: center;
  .status-bar {
    // height: pxTorem(48px);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }
  .header {
    line-height: pxTorem(88px) / 2;
    height: pxTorem(88px) / 2;
    position: relative;
    display: flex;
    justify-items: center;
    align-items: center;
  }
  .left-btn {
    padding: 0 r(10px);
    color: #333333;
    position: absolute;
    left: pxTorem(0px);
    height: pxTorem(88px) / 2;
    top: 50%;
    display: flex;
    justify-items: center;
    align-items: center;
    z-index: 9;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);

    .iconfont {
      display: block;
      width: r(56px);
      height: 100%;
      background-image: url(~images/back.png);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .right-btn {
    font-size: r(26px);
    padding: 0 r(30px);
    color: #272727;
    position: absolute;
    right: r(0px);
    height: r(88px);
    top: 50%;
    display: flex;
    justify-items: center;
    align-items: center;
    z-index: 9;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    .iconfont {
      display: block;
      width: pxTorem(40px);
      height: pxTorem(40px);
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .header-txt {
    width: 60%;
    margin: 0 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // flex: 1;
    //      display: inline-block;
    font-size: r(30px);
    font-weight: bold;
    color: #212121;
    line-height: r(46px);
  }
  .right-word {
    font-size: pxTorem(14px);
    color: #4a4a4a;
    position: absolute;
    right: pxTorem(20px);
  }
  .top-fixed-shadow {
    box-shadow: 0 pxTorem(3px) pxTorem(7px) rgba(0, 0, 0, 0.17);
  }
  &.top-fixed-shadow {
    box-shadow: 0 pxTorem(3px) pxTorem(7px) rgba(0, 0, 0, 0.17);
  }
}
</style>
<script>
export default {
  data() {
    return {};
  },
  props: ["title", "isback" , "isshow_share",'showRight'],
  methods: {
    goback() {
      tools.router.back();
    },
    wxShare(){
      this.$emit('show_share');
    }
  },
  watch: {},
  components: {},
  filters: {},
  mounted() {
    let that = this;
  }
};
</script>



// WEBPACK FOOTER //
// Top_fixed.vue?99e66d8a